import * as types from 'store/modules/hres3cu/mutation-types'
import hres3cu from 'api/hres3cu'
import swal from 'sweetalert'
import hres3cuLabels from 'assets/labels/hres3cu'
import { hres3cuColumns } from 'assets/columns/hres3cu'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    detailProcessDisp: false,
    labels: hres3cuLabels,
    columns: hres3cuColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {},
    detailProcess: {
      detail: {},
      table: {
        total: 0,
        rows: []
      }
    },
    complaints: {
      tab1: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab2: {}
    },
    detailPopupProcess: {
      numcom: '',
      dteopert: '',
      codopert: '',
      desopert: '',
      resopert: '',
      dteres: '',
      dteclose: '',
      staappr: ''
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES3CU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES3CU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES3CU_DETAIL_PROCESS_DISP] (state) {
      return state.detailProcessDisp
    },
    [types.GET_HRES3CU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES3CU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES3CU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES3CU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES3CU_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES3CU_DETAIL_PROCESS] (state) {
      return state.detailProcess
    },
    [types.GET_HRES3CU_DETAIL_PROCESS_POPUP] (state) {
      return state.detailPopupProcess
    },
    [types.GET_HRES3CU_DETAIL_TAB3_PROCESS] (state) {
      return state.detailProcessSelected
    }
  },
  mutations: {
    [types.SET_HRES3CU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES3CU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES3CU_DETAIL_PROCESS_DISP] (state, detailProcessDisp) {
      state.detailProcessDisp = detailProcessDisp
    },
    [types.SET_HRES3CU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailProcess = configLabel.replaceLabelToColumns(state.columns[keyLang].detailProcess, labels[keyLang])
        state.columns[keyLang].complaintsTab1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].complaintsTab1Table, labels[keyLang])
      }
    },
    [types.SET_HRES3CU_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES3CU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES3CU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES3CU_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES3CU_DETAIL_PROCESS] (state, data) {
      state.detailProcess = data
    },
    [types.SET_HRES3CU_DETAIL_PROCESS_POPUP] (state, detailPopupProcess) {
      state.detailPopupProcess = detailPopupProcess
    },
    [types.SET_HRES3CU_DETAIL_PROCESS_SELECTED] (state, detailProcessSelected) {
      state.detailProcessSelected = detailProcessSelected
    }
  },
  actions: {
    [types.TOGGLE_HRES3CU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      let detailProcessDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
        case 'detailProcess':
          detailProcessDisp = true
          break
      }
      commit(types.SET_HRES3CU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES3CU_DETAIL_DISP, detailDisp)
      commit(types.SET_HRES3CU_DETAIL_PROCESS_DISP, detailProcessDisp)
    },
    [types.RECEIVED_HRES3CU_COLUMNS_LABELS] ({ commit }) {
      hres3cu.getApiLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_COLUMNS, data.labels)
          commit(types.SET_HRES3CU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES3CU_INDEX] ({ commit }, searchParams) {
      hres3cu.getApiIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES3CU_DETAIL] ({ commit }, detailParams) {
      hres3cu.getApiDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES3CU_DETAIL_PROCESS] ({ commit }, detailProcessParams) {
      hres3cu.getApiDetailProcess(detailProcessParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_DETAIL_PROCESS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP_CREATE] ({ commit }) {
      hres3cu.getDetailProcessPopupCreate()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_DETAIL_PROCESS_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES3CU_DETAIL_PROCESS_POPUP] ({ commit }, popupParams) {
      hres3cu.getApiDetailProcessPopup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES3CU_DETAIL_PROCESS_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES3CU_DETAIL_PROCESS] ({ commit, dispatch }, {param, searchIndex, indexSelected, dataRowsHasFlg, detailProcessParams}) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      hres3cu.deleteApiDetailProcess({param, indexSelected, dataRowsHasFlg})
      .then((response) => {
        const data = JSON.parse(response.request.response)
        dispatch(types.RECEIVED_HRES3CU_INDEX, searchIndex)
        dispatch(types.RECEIVED_HRES3CU_DETAIL_PROCESS, detailProcessParams)
        swal({
          title: '', text: data.response, html: true, type: 'success'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.POST_HRES3CU_DETAIL_PROCESS_POPUP] ({ commit, dispatch }, {searchIndex, indexSelected, paramDetailProcess, referenceButton}) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres3cu.postApiDetailProcess({indexSelected, paramDetailProcess})
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES3CU_DETAIL_PROCESS, indexSelected)
              dispatch(types.RECEIVED_HRES3CU_INDEX, searchIndex)
              swal({title: '', text: data.response, html: true, type: 'success'}, function () {
                referenceButton.click()
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres3cu/index.js